import React from "react";
import { Typography, TextField, Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import InfoPopover from "../../../../utils/informationButton";

const TextResponseComponent = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <Typography variant="h6" className={props.classes.responseTitle}>
          {t("newEnigma.responses")}
        </Typography>
        <InfoPopover
          title={t("newEnigma.text_response")}
          text={t("newEnigma.reponseTexteInfo")}
          src="/images/reponse-text.webp"
        />
      </Box>
      <TextField
        required
        fullWidth
        id="textfield-responses"
        label={t("newEnigma.Réponses")}
        variant="outlined"
        size="small"
        className={props.classes.textfieldResponses}
        style={{
          width: "100%",
        }}
        value={props.state.formDatas.responsesTextStr || ""}
        onChange={props.updateResponsesText}
        minRows={2}
        multiline={true}
        key={
          props.state.enigmaLoaded ? "responsesNotLoaded" : "responsesLoaded"
        }
        inputProps={{ maxLength: 250 }}
      />
      <Typography
        style={{
          fontSize: "12px",
          color: "#94A3B8",
          textAlign: "right",
          marginTop: "4px",
        }}
      >
        {(props.state.formDatas.responsesTextStr || "").length}/250
      </Typography>
      <Typography className={props.classes.helperText}>
        {t("newEnigma.reponseMultipleInfo")}
      </Typography>
    </>
  );
};

export default TextResponseComponent;
